
import React from 'react';
import { confirmSignup } from '../Authentication/RegisterActions';
import { connect } from 'react-redux';
import { Alert, FormGroup, Container, Row, Col, Card, CardBody, Button, InputGroup} from 'reactstrap';
import DashboardLogoGroup from '../../components/DashboardLogoGroup';
import {Link} from 'react-router-dom';
import Waitable from '../../components/Waitable';

class ConfirmRegistrationContainer extends React.Component {


    componentDidMount() {
        let {match, dispatchConfirmSignup, customerConfirmSignup} = this.props;
        let token = match.params.token;
        
        dispatchConfirmSignup({
            token
        })

    }
    render() { 
         let {match, dispatchConfirmSignup, customerConfirmSignup} = this.props;

        const isFetching = customerConfirmSignup.get("isFetching");
        let err = false;
        if(!isFetching){
             err = customerConfirmSignup.get("error");        
        }
        
        return (
            <div>
                <Row>
                    <DashboardLogoGroup />
                </Row>
                <div className="app flex-row  animated fadeIn  mt-5 pt-5">
                    <Container>
                        <Waitable entities={[customerConfirmSignup]}>
                            {err ?   <Alert color="danger">
                                <p className="text-center" >{err.message}</p>
                            </Alert> : <Alert color="success">
                                <p className="text-center" >Thank you for your registration, your email is now confirmed.</p>
                            </Alert> }


                        <Link to="/login" id="goBack">Go Back to Login</Link>
                        </Waitable>
                    </Container>
                </div>

            </div>

        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        dispatchConfirmSignup: (data, cb) => dispatch(confirmSignup(data, cb))
    };
}

function mapStateToProps(state) {
    return {
        customerConfirmSignup: state.customerConfirmSignup
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmRegistrationContainer);


// WEBPACK FOOTER //
// ./src/containers/Register/ConfirmRegistrationContainer.js